import styled from 'styled-components';

import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const FlexContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: ${getPurpurSpacing('200')} 0;
    padding: 0;
    gap: ${getPurpurSpacing('200')};
`;

export const EnergyClassButton = styled.div`
    cursor: pointer;
    width: 4.875rem;
    height: 3rem;
`;

export const DocumentLink = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0;
`;
